import React from 'react';
import classes from './text.scss';
class Text extends React.Component {
  render() {
    const {
      inscription,
      styles,
      getRef,
      mediaId
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      id: mediaId,
      className: classes.text,
      "data-element": "text",
      "data-colors": styles.color,
      ref: getRef,
      style: styles
    }, inscription);
  }
}
export default Text;